import { createContext } from "react";

export const PanelContext = createContext(null);
